<template>
<Navbar />
<Header v-bind:title="$t('_title_news')" />

<div class="backToList">
  <a @click="$router.go(-1)"><font-awesome-icon icon="fa-solid fa-angles-left" />{{$t('news_goback')}}</a>
</div>

<section v-if="news">
    <h2 class="detail-title"> {{ news.title }} </h2>
    <p class="post-time">
      <font-awesome-icon icon="fa-regular fa-clock" /> Post on {{ formattedTimestamp(news.timestamp) }}
    </p>
    <div class="detail-content" v-html="news.content" />
</section>

<section v-else>
    Loading...
</section>

<Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import formatted from "@/mixin/formatted";

export default {
  name: "App",
  components: { Navbar, Header, Footer },
  props:["id"],
  mixins: [formatted],

  data() {
    return {
      news: null
    };
  },

  mounted() {
    if(this.$i18n.locale == 'zh'){
      fetch('https://oir.nccu.edu.tw/codeigniter/api/article/' + this.id)
      .then((respond) => respond.json())
      .then((data) => {
          this.news = data;
      })
      .catch((err) => console.log(err.message))
    }

    if(this.$i18n.locale == 'en'){
      fetch('https://oir.nccu.edu.tw/codeigniter/api/articleen/' + this.id)
      .then((respond) => respond.json())
      .then((data) => {
          this.news = data;
      })
      .catch((err) => console.log(err.message))
    }
  }
};
</script>

<style src="@/assets/css/news.css" scoped></style>
<style src="@/assets/css/detail.css"></style>